// tslint:disable
import * as React from 'react'
import './library-icon.css'

export const LibraryIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="47.456" height="58.318" viewBox="0 0 47.456 58.318">
    <g id="Group_7006">
      <path
        id="Path_23863"
        d="M5.251 136.071c-.043-1.027.685-.913 1.345-.917q4.1-.022 8.2-.053c0-.4.237-.971-.464-.976-3.245-.022-6.49-.01-10.034-.01.612.77-.438 1.818.953 1.956z"
        className="library-icon-cls-1"
        transform="translate(-2.876 -89.705)"
      />
      <path
        id="Path_23864"
        d="M6.709 171.032a1.205 1.205 0 0 0 .172-.026 1.205 1.205 0 0 1-.172.026z"
        className="library-icon-cls-1"
        transform="translate(-4.488 -114.383)"
      />
      <path
        id="Path_23865"
        d="M42.187 87.726c.061-2.186.159-4.371.171-6.557.014-2.329-.366-4.65.074-6.99a8.241 8.241 0 0 0-.072-3.605 9.517 9.517 0 0 1-.115-3.28 16.254 16.254 0 0 0 .009-4.825c-.492-2.357-.03-2.885 2.376-3.23.194-.028.366-.207.549-.316a12.164 12.164 0 0 0-3.966.133v11.122c0 5.4-.008 10.8.011 16.2.003.622-.334 1.598.963 1.348z"
        className="library-icon-cls-1"
        transform="translate(-27.549 -39.346)"
      />
      <path
        id="Path_23866"
        d="M50.6 30.14c.749.006 1.187-.161.949-1.018h-8.636c-1.021-1.651-.5-3.336-.643-4.938-.454-.066-.941-.125-.948.534-.021 1.784-.007 3.568-.007 5.413 3.256-.001 6.269-.015 9.285.009z"
        className="library-icon-cls-1"
        transform="translate(-27.632 -16.15)"
      />
      <path
        id="Path_23867"
        d="M51.3 163.235H41.262c.011.874-.245 1.632.154 2.355 1.066-1.339 2.567-1.037 3.979-1.046 2.024-.012 4.049 0 6.074 0 .062-.477.231-.97-.169-1.309z"
        className="library-icon-cls-1"
        transform="translate(-27.552 -109.185)"
      />
      <path
        id="Path_23868"
        d="M5.782 70.126q.012-3.519-.028-7.039c-.026-2.354-.175-4.715-.158-7.056a54.58 54.58 0 0 0-.059-6.552 16.48 16.48 0 0 1 .2-6.222c-.854-.132-.672.507-.677.953-.018 1.484-.011 2.968-.006 4.452q.041 11.373.087 22.746c.827-.115.639-.774.641-1.282z"
        className="library-icon-cls-1"
        transform="translate(-3.373 -28.922)"
      />
      <path
        id="Path_23869"
        d="M67.515 59.219c-.666-.828-1.53-.316-2.314-.341.693.649 1.545.213 2.314.341z"
        className="library-icon-cls-1"
        transform="translate(-43.612 -39.293)"
      />
      <path
        id="Path_23870"
        d="M14.521 12.273c.78.008.959-.326.814-1-3.105-.549-6.294.436-9.572-.411V5.36c-.382-.071-.656.031-.657.471-.006 2.117 0 4.234 0 6.43 3.281 0 6.348-.018 9.415.012z"
        className="library-icon-cls-1"
        transform="translate(-3.413 -3.572)"
      />
      <path
        id="Path_23871"
        d="M12.9 128.575a40.819 40.819 0 0 1-7.578-.261 40.846 40.846 0 0 0 7.578.261z"
        className="library-icon-cls-1"
        transform="translate(-3.563 -85.827)"
      />
      <path
        id="Path_23872"
        d="M21.1 43.271a4.777 4.777 0 0 1-.66.009l-2.466.005 2.466-.005a4.782 4.782 0 0 0 .66-.009z"
        className="library-icon-cls-1"
        transform="translate(-12.021 -28.943)"
      />
      <path
        id="Path_23873"
        d="M10.719 43.3H7.128h.762z"
        className="library-icon-cls-1"
        transform="translate(-4.768 -28.957)"
      />
      <path
        id="Path_23874"
        d="M86.682 72.225q0-.26.008-.521c-.363-.334-.475-.664.147-.764 3.476-.563 6.956-1.1 10.435-1.652l.015-.01c.02-.435.12-1.017-.562-.908-3.929.624-7.85 1.294-11.744 1.943a3.254 3.254 0 0 0 .212 1.885 2.085 2.085 0 0 0 1.489.027z"
        className="library-icon-cls-1"
        transform="translate(-56.813 -45.723)"
      />
      <path
        id="Path_23875"
        d="M91.071 102.119c-.122-1.141-.106-2.282-.325-3.43-.883-4.616-1.659-9.253-2.462-13.884-.117-.675-.49-1.358-.012-2.1 3.54-.593 7.073-1.343 10.682-1.608-.015-.315.112-.663-.265-.963l-12.261 2 3.315 20.1c.5.055.928.208 1.328-.115z"
        className="library-icon-cls-1"
        transform="translate(-57.81 -53.602)"
      />
      <path
        id="Path_23876"
        d="M88.991 54.834c1.405-.325 2.86-.422 4.262-.751-1.4.329-2.857.426-4.262.751l-5.168.739c-.023-1.088-.585-2-.255-3.067l3.153-.8c.079-.149.173-.182.291-.039l7.265-1.034c.072-.613-.344-.606-.739-.545-3.832.6-7.661 1.208-11.533 1.821a16.4 16.4 0 0 0 .629 4.423l6.385-1-.028-.498z"
        className="library-icon-cls-1"
        transform="translate(-54.847 -33.487)"
      />
      <path
        id="Path_23877"
        d="M94.2 76.7l-1.329.1-2.637.356 2.637-.356.4.3.925-.1 3.427-.49-3.427.49q-.003-.142.004-.3z"
        className="library-icon-cls-1"
        transform="translate(-60.354 -51.183)"
      />
      <path
        id="Path_23878"
        d="M111.852 159.736c.144-.944-.15-1.351-1.182-1.105-.907.216-1.851.267-2.766.449-2.824.564-5.727.718-8.561 1.51l.471 1.894 1.2-.18c2.339-.971 4.857-1.232 7.292-1.819 1.174-.285 2.363-.501 3.546-.749z"
        className="library-icon-cls-1"
        transform="translate(-66.449 -106.059)"
      />
      <path
        id="Path_23879"
        d="M99.135 150.57c-.054-.579.153-.846.785-.964 3.362-.627 6.713-1.315 10.068-1.982l.03.282-.03-.282c-.022-1.109-.829-.613-1.3-.561-1.3.146-2.6.391-3.89.606q-3.589.594-7.19 1.2c.074 1.179.019 2.213 1.527 1.701z"
        className="library-icon-cls-1"
        transform="translate(-65.291 -98.264)"
      />
      <path
        id="Path_23880"
        d="M117.207 62.5c.46-.058 1.162.018 1.185-.654-.029.671-.727.597-1.185.654z"
        className="library-icon-cls-1"
        transform="translate(-78.398 -41.368)"
      />
      <path
        id="Path_23881"
        fill="#0d455f"
        d="M47.355 54.038q-1.319-7.97-2.646-15.939-1.809-10.984-3.595-21.972c-.17-1.046-.589-1.563-1.777-1.318-1.832.378-3.691.625-5.539.923-2.627.424-5.255.843-7.969 1.278-.315-3.679.18-7.139-.328-10.658H13.663c0-1.653-.068-3.077.02-4.491.084-1.37-.447-1.871-1.812-1.845-3.2.061-6.4.1-9.6-.012C.582-.052-.007.419 0 2.225.072 20.315.051 38.406.068 56.5c0 .524-.183 1.1.178 1.539h25.512v-34c1.3 5.332 2.219 10.679 3.106 16.031q1.387 8.372 2.72 16.752c.193 1.218.7 1.707 2 1.425 1.875-.405 3.792-.611 5.679-.966a76.461 76.461 0 0 0 7.976-1.481 2.589 2.589 0 0 0 .116-1.762zM1.693 2.259c0-.44.275-.541.657-.471h9.572V7.7c.145.673-.034 1.007-.814 1-3.067-.028-6.134-.01-9.418-.01 0-2.197-.003-4.314.003-6.431zm.708 8.1h4.971l4.217.034c.593.163.323.62.334.981.188.821-.061 1.23-.98 1.221-3-.027-6-.01-9.178-.01a1.963 1.963 0 0 0-.083-.815c-.147-.582-.305-1.125.718-1.408zm-.637 32.128l-.087-22.746c-.005-1.484-.012-2.968.006-4.453.005-.446-.177-1.085.677-.953H5.951l2.466-.005a4.777 4.777 0 0 0 .66-.009c.13-.01.261-.023.392-.036l.12-.012c.273-.028.545-.056.816-.061a3.651 3.651 0 0 1 .438.017 2.626 2.626 0 0 1 .434.079 2.283 2.283 0 0 1 .638.284v28.201c-.432-.024-.862-.037-1.29-.044s-.856-.006-1.282 0a40.846 40.846 0 0 1-7.578-.26zm-.34 1.923c3.544 0 6.789-.012 10.034.01.7 0 .468.573.464.976a1.873 1.873 0 0 1 .051.285 1 1 0 0 1 0 .231c-.059.411-.427.525-1 .516-2.863-.043-5.727-.045-8.591-.062-1.399-.138-.349-1.186-.958-1.956zm10.483 5.2v7.013H2.393a1.2 1.2 0 0 1-.172.026.448.448 0 0 1-.512-.3.963.963 0 0 1-.045-.313v-7.781h10.018c.488.381.272.883.224 1.355zm1.782-41.043c.007-.658.494-.6.948-.534h9.208a16.777 16.777 0 0 1 .168 3.115c-.018.611-.056 1.217-.1 1.823.238.858-.2 1.024-.949 1.018-3.013-.023-6.027-.01-9.284-.01.003-1.844-.011-3.628.009-5.412zm-.015 38.461c-.019-5.4-.011-10.8-.011-16.2v-11.12a12.164 12.164 0 0 1 3.966-.133 16.471 16.471 0 0 1 1.98-.11 17.716 17.716 0 0 1 1.979.121c.784.025 1.648-.487 2.314.341l.095 24.892v3.561h-9.359c-1.297.25-.961-.727-.963-1.352zm9.68 9.588c-3.164-.066-6.34.348-9.491-.212-.4-.723-.143-1.48-.154-2.355h10.039c.4.339.231.832.169 1.307.073.544.255 1.277-.562 1.26zm.353-4.4h-9.75c-.552-.616-.2-1.283-.311-2.027h10.2a2.229 2.229 0 0 1-.138 2.023zm.1-34.438H13.79a3.979 3.979 0 0 1 0-2.1h9.972a2.409 2.409 0 0 1 .048 2.097zm3.348.651c3.872-.613 7.7-1.223 11.533-1.821.4-.062.811-.068.739.545.175.989.35 1.977.525 2.956a1.465 1.465 0 0 1 .039.374c-.024.672-.725.6-1.185.654-.035 0-.069.01-.1.016-1.5.3-3.022.474-4.536.7l-6.385 1a16.4 16.4 0 0 1-.627-4.428zm1.01 6.165c3.893-.649 7.815-1.319 11.744-1.943.682-.109.582.473.562.908a1.613 1.613 0 0 1 .2 1.294l-3.406.487-3.427.49-.925.1-3.045.577a2.085 2.085 0 0 1-1.49-.027 3.254 3.254 0 0 1-.211-1.89zm3.765 24.045c-1.1-6.64-2.186-13.25-3.315-20.1l12.261-2c.377.3.25.648.265.963.677 4.1 1.362 8.205 2.028 12.31.367 2.261.7 4.526 1.09 7.011l-11 1.7c-.398.317-.825.163-1.327.112zm.388 1.968q3.607-.6 7.19-1.2c1.295-.214 2.587-.46 3.89-.606.467-.052 1.274-.548 1.3.561l.03.282.1.958-10.983 1.7c-1.51.516-1.455-.518-1.524-1.702zm12.416 4.064q-5.086.787-10.172 1.578l-1.2.18-.471-1.894c2.835-.792 5.738-.946 8.561-1.51.916-.183 1.86-.234 2.766-.449 1.032-.245 1.326.162 1.182 1.105.263.651-.077.896-.663.986z"
      />
      <path
        id="Path_23882"
        d="M12.9 71.7h1.282c.429 0 .859.02 1.29.044V43.557c-1.172-.01-2.367.291-3.5-.263l-2.458.006a3.3 3.3 0 0 1-2.829 0h-.762a16.48 16.48 0 0 0-.2 6.222 54.58 54.58 0 0 1 .059 6.552c-.018 2.341.132 4.7.158 7.056s.036 4.693.028 7.039c0 .508.185 1.167-.645 1.283a40.82 40.82 0 0 0 7.577.248z"
        className="library-icon-cls-3"
        transform="translate(-3.563 -28.957)"
      />
      <path
        id="Path_23883"
        d="M44.056 62.442a16.254 16.254 0 0 1-.009 4.825 9.517 9.517 0 0 0 .115 3.28 8.241 8.241 0 0 1 .072 3.605c-.44 2.34-.06 4.661-.074 6.99-.013 2.186-.111 4.372-.171 6.557h9.361v-3.561q-.046-12.446-.095-24.892c-.77-.128-1.622.308-2.314-.341a17.716 17.716 0 0 0-1.979-.121 16.47 16.47 0 0 0-1.98.11c-.182.109-.355.288-.549.316-2.406.347-2.869.875-2.377 3.232z"
        className="library-icon-cls-4"
        transform="translate(-29.351 -39.32)"
      />
      <path
        id="Path_23884"
        d="M91.529 86.752c.8 4.631 1.579 9.268 2.463 13.884.22 1.148.2 2.289.325 3.43l11-1.7c-.385-2.485-.723-4.75-1.09-7.011-.667-4.1-1.351-8.207-2.028-12.31-3.609.266-7.142 1.015-10.682 1.608-.478.741-.105 1.424.012 2.099z"
        className="library-icon-cls-5"
        transform="translate(-61.056 -55.548)"
      />
      <path
        id="Path_23885"
        d="M7.226 149.458v7.135h9.514v-7.013a68.606 68.606 0 0 1-9.514-.122z"
        className="library-icon-cls-3"
        transform="translate(-4.833 -99.97)"
      />
      <path
        id="Path_23886"
        d="M16.67 11.316V5.4H7.1v5.5c3.276.852 6.465-.133 9.57.416z"
        className="library-icon-cls-3"
        transform="translate(-4.748 -3.613)"
      />
      <path
        id="Path_23887"
        d="M44.831 29.2h8.634c.042-.606.08-1.212.1-1.823a16.777 16.777 0 0 0-.165-3.117h-9.212c.141 1.602-.378 3.287.643 4.94z"
        className="library-icon-cls-4"
        transform="translate(-29.55 -16.227)"
      />
      <path
        id="Path_23888"
        d="M89.91 52.851l-.044.018-.03.012-.15-.017-3.153.8c-.33 1.068.232 1.978.255 3.067l5.168-.739c1.405-.325 2.86-.421 4.262-.751.284-.067.567-.14.846-.23.236-.076.471-.163.7-.261-.176-.978-.351-1.967-.525-2.956l-7.265 1.034z"
        className="library-icon-cls-5"
        transform="translate(-57.811 -34.642)"
      />
      <path
        id="Path_23889"
        d="M41.356 47.329a3.979 3.979 0 0 0 0 2.1h10.02a2.409 2.409 0 0 0-.051-2.1z"
        className="library-icon-cls-4"
        transform="translate(-27.569 -31.657)"
      />
      <path
        id="Path_23890"
        d="M41.193 151.563c.115.744-.241 1.412.311 2.027h9.751a2.229 2.229 0 0 0 .133-2.027z"
        className="library-icon-cls-4"
        transform="translate(-27.548 -101.378)"
      />
      <path
        id="Path_23891"
        d="M15.04 145.733H5.021v7.781a.963.963 0 0 0 .045.313.448.448 0 0 0 .512.3 1.205 1.205 0 0 0 .172-.026v-7.135a68.613 68.613 0 0 0 9.514.122c.049-.472.264-.973-.224-1.355z"
        className="library-icon-cls-4"
        transform="translate(-3.359 -97.478)"
      />
      <path
        id="Path_23892"
        d="M4.947 33.526c3.173 0 6.176-.017 9.178.01.919.008 1.169-.4.98-1.221-2.741-.018-5.482-.041-8.223-.051-.688 0-1.389.057-1.3-.969-1.024.283-.866.825-.719 1.416a1.963 1.963 0 0 1 .084.815z"
        className="library-icon-cls-4"
        transform="translate(-3.182 -20.933)"
      />
      <path
        id="Path_23893"
        d="M102.981 151.053c-.632.118-.839.384-.785.964l10.983-1.7-.1-.958-.03-.282c-3.354.661-6.705 1.349-10.068 1.976z"
        className="library-icon-cls-5"
        transform="translate(-68.352 -99.711)"
      />
      <path
        id="Path_23894"
        d="M45.849 167.141c-1.412.008-2.913-.293-3.979 1.046 3.152.56 6.328.145 9.491.212.817.017.635-.717.562-1.259-2.023-.001-4.05-.01-6.074.001z"
        className="library-icon-cls-4"
        transform="translate(-28.006 -111.782)"
      />
      <path
        id="Path_23895"
        d="M7.168 138.069c2.863.017 5.727.019 8.591.062.577.009.946-.105 1-.516a1 1 0 0 0 0-.231 1.872 1.872 0 0 0-.051-.285l-8.2.053c-.655.004-1.382-.11-1.34.917z"
        className="library-icon-cls-3"
        transform="translate(-4.794 -91.703)"
      />
      <path
        id="Path_23896"
        d="M8.535 32.264c2.741.009 5.482.032 8.223.051-.011-.361.259-.818-.334-.981a7.436 7.436 0 0 1-4.217-.034H7.236c-.09 1.021.611.962 1.299.964z"
        className="library-icon-cls-3"
        transform="translate(-4.835 -20.933)"
      />
      <path
        id="Path_23897"
        d="M111.682 162.859c-2.436.587-4.953.848-7.292 1.819l10.172-1.578c.585-.09.926-.336.666-.99-1.182.248-2.372.466-3.546.749z"
        className="library-icon-cls-5"
        transform="translate(-69.825 -108.433)"
      />
      <path
        id="Path_23898"
        d="M107.823 72.077a26.132 26.132 0 0 0-5.621 1.029v.305l3.427-.49 3.406-.487a1.613 1.613 0 0 0-.2-1.294l-.015.01c.386 1.075-.487.85-.997.927z"
        className="library-icon-cls-4"
        transform="translate(-68.359 -47.584)"
      />
      <path
        id="Path_23899"
        d="M107.382 61.208c-1.4.33-2.857.426-4.262.751l.028.5c1.514-.224 3.038-.4 4.536-.7.032-.007.066-.012.1-.016.458-.058 1.156.016 1.185-.654a1.465 1.465 0 0 0-.039-.374c-.232.1-.467.184-.7.261-.281.092-.563.165-.848.232z"
        className="library-icon-cls-4"
        transform="translate(-68.976 -40.612)"
      />
      <path
        id="Path_23900"
        d="M90.216 77.747q0 .261-.008.521l3.045-.577-.4-.3z"
        className="library-icon-cls-4"
        transform="translate(-60.339 -51.765)"
      />
      <path
        id="Path_23901"
        d="M26.481 31.341l-4.217-.034a7.436 7.436 0 0 0 4.217.034z"
        className="library-icon-cls-4"
        transform="translate(-14.892 -20.941)"
      />
      <path
        id="Path_23902"
        d="M25.419 43.058c1.13.554 2.325.253 3.5.263a2.284 2.284 0 0 0-.638-.284 2.627 2.627 0 0 0-.434-.079 3.653 3.653 0 0 0-.438-.017c-.271 0-.543.032-.816.061l-.12.012c-.131.014-.262.026-.392.036a4.783 4.783 0 0 1-.662.008z"
        className="library-icon-cls-4"
        transform="translate(-17.003 -28.722)"
      />
      <path
        id="Path_23903"
        d="M12.258 43.307H9.429a3.3 3.3 0 0 0 2.829 0z"
        className="library-icon-cls-4"
        transform="translate(-6.307 -28.965)"
      />
      <path
        id="Path_23904"
        d="M96.444 54.772l.044-.018.067-.026c-.118-.143-.212-.109-.291.039l.15.017z"
        className="library-icon-cls-4"
        transform="translate(-64.39 -36.546)"
      />
      <path
        id="Path_23905"
        d="M96.852 54.993l-.044.018z"
        className="library-icon-cls-4"
        transform="translate(-64.754 -36.784)"
      />
      <path
        id="Path_23906"
        d="M93.6 73.126a26.132 26.132 0 0 1 5.621-1.026c.51-.079 1.383.148.994-.928-3.479.548-6.959 1.089-10.435 1.652-.622.1-.509.429-.147.764l2.637-.356z"
        className="library-icon-cls-5"
        transform="translate(-59.757 -47.604)"
      />
    </g>
  </svg>
)
